import { render, staticRenderFns } from "./VuesticTooltip.vue?vue&type=template&id=9885bbfa&scoped=true"
import script from "./VuesticTooltip.vue?vue&type=script&lang=js"
export * from "./VuesticTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9885bbfa",
  null
  
)

export default component.exports